import React, { useState } from 'react'
import "./Notiboard.css"
function Notiboard({ title, text, btm }) {
    const [close, setClose] = useState(false);
    return close ? <div /> : <div className="Notiboard_root" onClick={() => setClose(true)}><div className="Notiboard_top"> {title} </div><div className="Notiboard_center"> {text}</div><div className="Notiboard_btm">{btm}</div></div>
}
export default Notiboard